webpackJsonp([49775852442029],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(props) {
	  var title = props.title,
	      url = props.url,
	      description = props.description;
	
	  return _react2.default.createElement(
	    'section',
	    { id: title, className: 'work_project' },
	    _react2.default.createElement(
	      'section',
	      { className: 'description' },
	      _react2.default.createElement(
	        'a',
	        {
	          title: title,
	          href: url,
	          rel: 'noreferrer nofollow noopener',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        description
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          title: title,
	          href: url,
	          rel: 'noreferrer nofollow noopener',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'button_secondary',
	            style: { margin: '10px 0' }
	          },
	          'Visit'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var PROJECTS = [{
	  title: 'Beastgrip',
	  description: 'A fast-growing e-commerce website and blog for an advanced mobile photography and filmmaking hardware startup based out of Chicago, IL.',
	  url: 'https://beastgrip.com',
	  id: 5
	}, {
	  title: 'Mail For Good',
	  description: 'A documentation website for Mail For Good, a trending email marketing software platform from the non-profit organization Free Code Camp.',
	  url: 'http://mail-for-good.netlify.com',
	  id: 4
	},
	/* {
	  title: 'Chicago Web Developers',
	  description: 'A landing page website for Chicago Web Developers, an innovative local web development consultancy.',
	  url: 'https://chicagowebdevelopers.co',
	  id: 3,
	}, */
	{
	  title: 'Mobile Innovation Network Australasia',
	  description: 'A full-featured website and blog for an influential mobile filmmaking non-profit organization in Australia.',
	  url: 'http://mina.pro',
	  id: 2
	}, {
	  title: 'Miller Street Studios',
	  description: 'A landing page and blog website for a specialized Chicago-based audio recording studio.',
	  url: 'http://millerstreetstudios.com',
	  id: 1
	}];
	
	exports.default = PROJECTS;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Project = __webpack_require__(204);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _PROJECTS = __webpack_require__(208);
	
	var _PROJECTS2 = _interopRequireDefault(_PROJECTS);
	
	var _PageWrapperSlim = __webpack_require__(19);
	
	var _PageWrapperSlim2 = _interopRequireDefault(_PageWrapperSlim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects() {
	  return _react2.default.createElement(
	    _PageWrapperSlim2.default,
	    {
	      title: 'Experience',
	      id: 'experience',
	      description: 'See my accomplishments and work history.',
	      url: 'https://seanlawrence.co/experience'
	    },
	    _PROJECTS2.default.map(function (project) {
	      var title = project.title,
	          description = project.description,
	          url = project.url,
	          id = project.id;
	
	      return _react2.default.createElement(_Project2.default, {
	        title: title,
	        description: description,
	        url: url,
	        key: id
	      });
	    })
	  );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-experience-js-a510c615647ca72623bc.js